import * as React from 'react';

import { Text } from '../../Text';
import { IJKInfoSchema } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/JKInfoSchema';

export interface IIJKInfoProps {
  jkInfo: IJKInfoSchema;
}

export function JKInfo({ jkInfo }: IIJKInfoProps) {
  const { deadlineText, floorText, materialTypeText } = jkInfo;

  return (
    <>
      {deadlineText && (
        <div>
          <Text textSize="small" color="gray">
            {deadlineText}
          </Text>
        </div>
      )}
      {floorText && (
        <div>
          <Text textSize="small" color="gray">
            {floorText}
          </Text>
        </div>
      )}
      {materialTypeText && (
        <div>
          <Text textSize="small" color="gray">
            {materialTypeText}
          </Text>
        </div>
      )}
    </>
  );
}
